module.exports = __webpack_public_path__ + "static/media/9.0495cd35.JPG";